var React = require('react');

function Curbside (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 5h-4.762a4.457 4.457 0 0 1 .712 2H20a1 1 0 0 1 1 1v1h-6.354a3.491 3.491 0 0 0-5.621-3.975A5.6 5.6 0 0 0 8 6.715a5.6 5.6 0 0 0-1.025-1.69 3.5 3.5 0 0 0-4.95 4.95 5.529 5.529 0 0 0 3.248 1.007 16.578 16.578 0 0 0-2.664 3.564l1.781.908A15.036 15.036 0 0 1 8 11.2a15.036 15.036 0 0 1 3.609 4.256l1.781-.908A16.552 16.552 0 0 0 10.743 11H21v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3.471a12.61 12.61 0 0 0-1.719 2.38L5 16.46V17a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3zM3.438 8.559a1.5 1.5 0 0 1 2.123-2.12 7.916 7.916 0 0 1 1.144 2.592 7.849 7.849 0 0 1-3.267-.472zm9.125 0A5.577 5.577 0 0 1 10.218 9h-.913a7.948 7.948 0 0 1 1.134-2.561 1.5 1.5 0 0 1 2.124 2.12z"}));
}

Curbside.defaultProps = {"fill":"#000000","width":"800px","height":"800px","viewBox":"0 0 24 24"};

module.exports = Curbside;

Curbside.default = Curbside;
